import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import PropTypes from 'prop-types'

const Checkbox = (props) => {
  const { onClick, label, id, checked, disabled, labelTxt } = props

  const [isChecked, setIsChecked] = useState(checked)
  const [clickCount, setClickCount] = useState(0)
  const checkboxEl = useRef(null)

  useEffect(() => {
    // when the prop changes force the state to update
    setIsChecked(checked)
  }, [checked])

  useEffect(() => {
    if (clickCount > 0) {
      const clickData = {
        clickedEl: checkboxEl.current,
        isChecked,
        value: id,
      }

      onClick(clickData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickCount, isChecked])

  // eslint-disable-next-line no-unused-vars
  const toggleCheck = (e) => {
    setIsChecked(!isChecked)
    setClickCount(clickCount + 1)
  }

  const icon = isChecked ? (
    <FontAwesomeIcon icon={faCheck} size="sm" />
  ) : (
    <svg className="svg-inline--fa fa-w-16 fa-sm svg-empty" />
  )

  const inputId = `${labelTxt || label}-${id}`

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span onClick={toggleCheck} ref={checkboxEl} className={`cb-wrap ${disabled ? 'disable' : ''}`}>
      <input
        type="checkbox"
        disabled={disabled}
        id={inputId}
        onChange={toggleCheck}
        checked={isChecked}
      />
      <span>{icon}</span>
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label htmlFor={inputId}>{label}</label>
    </span>
  )
}

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  labelTxt: null,
}

Checkbox.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.any.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  labelTxt: PropTypes.string,
}

export default Checkbox
